import { Zap, X } from 'lucide-react'
import type { ScorecardMark } from './types'

/** Two decimals when there are any, as the board shows them. */
export function formatPoints(points: number): string {
  return Number.isInteger(points) ? String(points) : points.toFixed(2)
}

/** Dark for a top, the brand colour for a flash, an outline for nothing. */
export const MARK_STYLE: Record<ScorecardMark | 'none', string> = {
  top: 'bg-foreground text-background border-foreground',
  flash: 'bg-primary text-primary-foreground border-primary',
  none: 'border-divider text-foreground/50',
}

/** The small square used in the legend and the toppers list. */
export function MarkSwatch({ mark }: { mark?: ScorecardMark }) {
  return (
    <span
      className={`inline-grid size-[18px] shrink-0 place-items-center rounded-[5px] border-[1.5px] ${MARK_STYLE[mark ?? 'none']}`}
      aria-hidden="true"
    >
      {mark === 'flash' ? (
        <Zap className="size-3" strokeWidth={2.5} />
      ) : mark === 'top' ? (
        <X className="size-3" strokeWidth={3} />
      ) : null}
    </span>
  )
}
